export default {
  moves: 0,
  authors: {},
  vector: { initialized: false },
  events: { featured: null, feed: null },
  content: { ready: false, title: null, meta: {} },
  posts: { cache: {}, offset: null, offsetFeatured: null, total: null },
  categories: {
    culture: { name: 'culture', label: 'Culture' },
    geeks: { name: 'geeks', label: 'Aspirante geek' },
    initiatives: { name: 'initiatives', label: 'Initiatives' },
    marketing: { name: 'marketing', label: 'Marketing' },
    specimens: { name: 'specimens', label: 'Spécimens SPK' }
  }
}



// WEBPACK FOOTER //
// ./src/store/init-state.js